import useStorage from "../../../Utils/useStorage";
import Config from "../../../config";
import useCurrentDate from "../../../Utils/useCurrentDate";
import { useUpdateEffect } from "react-use";
import { Modal } from "antd";

export default function useBatchPicker() {
    const [batch, setBatch] = useStorage(
        "batch",
        localStorage.getItem("batch") || Config.DefaultBatch
    );
    const { syncFromServer } = useCurrentDate();

    useUpdateEffect(() => {
        syncFromServer();
    }, [batch]);

    const handleChangeBatch = (batch: string) => {
        Modal.confirm({
            title: "提示：",
            content:
                "切换学期后，系统中的课程、作业、考试等均为所选学期下的内容。",
            onOk: () => setBatch(batch)
        });
    };

    return { batch, handleChangeBatch };
}
